import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, formatError } from "@/lib/api";
import { Field, Spinner } from "@/components/Field";
import { AuthShell } from "./AuthShell";

export default function ResetPasswordPage() {
  const { token } = useParams();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [msg, setMsg] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setMsg("Le password non coincidono");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      setDone(true);
    } catch (err) {
      setMsg(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Nuova password" subtitle="Almeno 8 caratteri.">
      {done ? (
        <div className="space-y-4">
          <p data-testid="reset-success" className="text-green-800 bg-green-50 border border-green-200 rounded-md p-3">Password aggiornata.</p>
          <Link to="/login" data-testid="reset-go-login"><Button className="w-full h-12">Vai all'accesso</Button></Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Field label="Nuova password"><Input data-testid="reset-password-input" type="password" minLength={8} required value={pw} onChange={(e) => setPw(e.target.value)} className="h-12" /></Field>
          <Field label="Ripeti password"><Input data-testid="reset-password2-input" type="password" minLength={8} required value={pw2} onChange={(e) => setPw2(e.target.value)} className="h-12" /></Field>
          {msg && <p data-testid="reset-error" className="text-sm text-red-700">{msg}</p>}
          <Button data-testid="reset-submit-button" type="submit" disabled={busy} className="w-full h-12">{busy ? <Spinner /> : "Salva password"}</Button>
        </form>
      )}
    </AuthShell>
  );
}
